import * as Yup from "yup";
import {
  formatCurrency,
  fromDateTimeLocalValue,
  toDateTimeLocalValue,
} from "../utils/formatters";

export const couponInitialValues = {
  id: "",
  coupon_code: "",
  coupon_type: "",
  discount_value: "",
  extra_trial_days: "",
  usage_limit: "",
  expires_at: "",
};

export const couponValidationSchema = Yup.object({
  coupon_code: Yup.string().trim().required("Coupon code is required"),
  coupon_type: Yup.string().trim().required("Coupon type is required"),
  discount_value: Yup.number()
    .typeError("Discount value must be a number")
    .min(0, "Discount value cannot be negative")
    .required("Discount value is required"),
  extra_trial_days: Yup.number()
    .typeError("Extra trial days must be a number")
    .min(0, "Extra trial days cannot be negative")
    .required("Extra trial days is required"),
  usage_limit: Yup.number()
    .typeError("Usage limit must be a number")
    .min(1, "Usage limit must be at least 1")
    .required("Usage limit is required"),
  expires_at: Yup.string().required("Expiry date is required"),
});

export const couponFields = [
  {
    name: "coupon_code",
    label: "Coupon code",
    placeholder: "WELCOME25",
  },
  {
    name: "coupon_type",
    label: "Coupon type",
    placeholder: "PERCENTAGE, FIXED, TRIAL_EXTENSION",
  },
  {
    name: "discount_value",
    label: "Discount value",
    type: "number",
    min: 0,
    step: "0.01",
    placeholder: "25",
  },
  {
    name: "extra_trial_days",
    label: "Extra trial days",
    type: "number",
    min: 0,
    step: 1,
    placeholder: "7",
  },
  {
    name: "usage_limit",
    label: "Usage limit",
    type: "number",
    min: 1,
    step: 1,
    placeholder: "100",
  },
  {
    name: "expires_at",
    label: "Expiry date",
    type: "datetime-local",
    placeholder: "Select expiry date and time",
  },
];

export const mapCouponToFormValues = (record) => ({
  ...couponInitialValues,
  id: record?.id || "",
  coupon_code: record?.coupon_code || "",
  coupon_type: record?.coupon_type || "",
  discount_value: record?.discount_value ?? "",
  extra_trial_days: record?.extra_trial_days ?? "",
  usage_limit: record?.usage_limit ?? "",
  expires_at: toDateTimeLocalValue(record?.expires_at),
});

export const mapCouponToPayload = (values, existingRecord) => ({
  ...(existingRecord?.id ? { id: existingRecord.id } : {}),
  coupon_code: values.coupon_code.trim(),
  coupon_type: values.coupon_type.trim(),
  discount_value: Number(values.discount_value),
  extra_trial_days: Number(values.extra_trial_days),
  usage_limit: Number(values.usage_limit),
  expires_at: fromDateTimeLocalValue(values.expires_at),
  ...(typeof existingRecord?.used_count === "number"
    ? { used_count: existingRecord.used_count }
    : {}),
  ...(typeof existingRecord?.isActive === "boolean"
    ? { isActive: existingRecord.isActive }
    : {}),
});

export const formatCouponDiscount = (record) => {
  const couponType = String(record?.coupon_type || "").toLowerCase();

  if (couponType.includes("percent")) {
    return `${record?.discount_value ?? 0}%`;
  }

  return formatCurrency(record?.discount_value);
};
